export const COLORS = [
	{
		id: 'default',
		label: 'Default',
		color1: '#fea58e',
		color2: '#51d3d9',
		color3: '#bda9ea',
	},
	{
		id: 'orange',
		label: 'Orange',
		color1: '#b86554',
		color2: '#e78f7b',
		color3: '#ffc2ac',
	},

	{
		id: 'aqua',
		label: 'Aqua',
		color1: '#008a90',
		color2: '#29b7bd',
		color3: '#64e4ea',
	},

	{
		id: 'purple',
		label: 'purple',
		color1: '#8472af',
		color2: '#af9cdc',
		color3: '#ddc8ff',
	},

	{
		id: 'yellow',
		label: 'Yellow',
		color1: '#eca531',
		color2: '#fec76f',
		color3: '#ffdca3',
	},
	{
		id: 'blue',
		label: 'Blue',
		color1: '#0d6294',
		color2: '#3981b9',
		color3: '#6aabe6',
	},
	{
		id: 'green',
		label: 'Green',
		color1: '#517846',
		color2: '#59884a',
		color3: '#98c886',
	},
];
